import type { CheckoutBlueprintPriceBreakdown as GQLItem } from '../generated/checkout.graphql';
import { take } from '../util/takePayload';

export type CheckoutBlueprintPriceBreakdown = {
  price: number;
  displayPrice: number;
  convenienceFee: number;
  taxFee: number;
  ccFee: number;
};

export const fromGql = (gqlItem: GQLItem): CheckoutBlueprintPriceBreakdown =>
  take(gqlItem, 'price', 'displayPrice', 'convenienceFee', 'taxFee', 'ccFee') as CheckoutBlueprintPriceBreakdown;
